import Badge from "../../../../components/badge/badge";
import { connect } from "react-redux";
export default connect(state => ({
  value: state.userMenu.unreadMessages,
  size: 12,
  color: "white"
}))(Badge);
